import { BadgesNames } from 'models/badges';

const EXPERTE_IM_FACH = '/icons/badges/experte-im-fach.png';
const EXPERTE_IM_FACH_x2 = '/icons/badges/experte-im-fach_2x.png';
const EXZELLENTER_UNTERRICHT = '/icons/badges/exzellenter-unterricht.png';
const EXZELLENTER_UNTERRICHT_x2 = '/icons/badges/exzellenter-unterricht_2x.png';
const LERNEN_MIT_SPASS = '/icons/badges/lernen-mit-spass.png';
const LERNEN_MIT_SPASS_x2 = '/icons/badges/lernen-mit-spass_2x.png';
const MOTIVATOR = '/icons/badges/motivator.png';
const MOTIVATOR_x2 = '/icons/badges/motivator_2x.png';
const SUPER_FLEXIBEL = '/icons/badges/super-flexibel.png';
const SUPER_FLEXIBEL_x2 = '/icons/badges/super-flexibel_2x.png';
const TOP_KOMMUNIKATION = '/icons/badges/top-kommunikation.png';
const TOP_KOMMUNIKATION_x2 = '/icons/badges/top-kommunikation_2x.png';

type BadgesObj = { [P in BadgesNames]: any };

const badgeIconsMobile: BadgesObj = {
  MOTIVATOR: MOTIVATOR,
  FUN_LEARNING: LERNEN_MIT_SPASS,
  FLEXIBLE: SUPER_FLEXIBEL,
  EXPERT: EXPERTE_IM_FACH,
  EXCELLENT: EXZELLENTER_UNTERRICHT,
  COMMUNICATION: TOP_KOMMUNIKATION,
};

const badgeIconsLarge: BadgesObj = {
  MOTIVATOR: MOTIVATOR_x2,
  FUN_LEARNING: LERNEN_MIT_SPASS_x2,
  FLEXIBLE: SUPER_FLEXIBEL_x2,
  EXPERT: EXPERTE_IM_FACH_x2,
  EXCELLENT: EXZELLENTER_UNTERRICHT_x2,
  COMMUNICATION: TOP_KOMMUNIKATION_x2,
};

export const getBadgeIcon = (badge: BadgesNames, minTablet = true) =>
  minTablet ? badgeIconsLarge[badge] : badgeIconsMobile[badge];
